export default {
    user_export_remind_1: "Dadurch wird die Excel-Datei des Nutzers heruntergeladen. Möchten Sie fortfahren?",
    start_download:"Download gestartet",
    cancel_download:"Download abgebrochen",
    modify_success:"Erfolgreich modifiziert",
    enabled:"Aktiviert",
    disabled:"deaktiviert",
    open:"auf",
    unopen:"zu",
    ac:"AC",
    dc:"DC",
    charging_capacity:"Charging Amount(Kwh)",
    service_fee_amount:"Service fee (yuan)",
    paid_amount:"Total cost actually paid (yuan)",
    notUserGroup_order_paid:"Non-user group has paid for charging order",
    level_day_task1:"Users of all levels do not need to be relegated",
    level_day_task2:"Relegation tasks for users of all levels every 30 days",
    level_day_task3:"Relegation tasks for users of all levels every 90 days",
    level_initial:"Mitgliedschaftsstufe zuweisen",
    level_initial_time:"Start time of user initialization level data:",
    selectTime: "Zeit wählen",
    initial:"initialization",
    think_again:"Denk nochmal",
    initial_info_wait:"Initialisieren der Benutzerebene, bitte warten...",
    initial_info_success:"Benutzerebene erfolgreich initialisiert!",
    fee_policy_push_remind1:"Bei Änderungen im Tarifstandard klicken Sie bitte im Stationsdetail ->Tarifstandard auf 'Tarif auslösen', damit der Tarif in Kraft treten kann.",
    fee_policy_push_remind2:"Kein Rabatt für gesamte Gebühr jedes einzelnen Aufladens",
    fee_policy_push_remind3:"Rabatt für Servicegebühr jedes einzelnen Aufladens",
    fee_policy_push_remind4:"Rabatt für gesamte Gebühr jedes einzelnen Aufladens",
    member_00000: 'Mitgliederverwaltung',
    member_00001: 'Mitgliederinformation',
    member_00002: 'Affiliate-Marketing',
    member_00003: 'Pegeleinstellung',
    member_00004: 'Eigenkapitaleinstellung',
    member_00005: 'Level aktivieren',
    member_00006: 'offen',
    member_00007: 'nah dran',
    member_00008: 'Benutzer exportieren',
    member_00009: 'Stufe (von niedrig nach hoch)',
    member_00010: 'Level',
    member_00011: 'Klassenname',
    member_00012: 'Benutzernummer',
    member_00013: 'Anzahl der Marketingaktivitäten',
    member_00014: 'Marketing Aktivitäten',
    member_00015: 'Benutzer anzeigen',
    member_00016: 'Kontrolle der Marketingaktivitäten',
    member_00017: 'Ob der Gutscheinrabatt aktiviert werden soll',
    member_00018: 'Einrichtungshilfe',
    member_00019: '1.如设置为启用卡券优惠，则等级用户支付订单时，可以使用卡券；如设置为不启用卡券优惠，等级用户支付订单时不能使用卡券。',
    member_00020: '2.支付订单时优先使用等级用户特权，使用等级用户特权后的账单金额再根据卡券满足条件选择使用的卡券。',
    member_00020_1: '例：VIP用户此次充电费用100元(含电费70元、服务费30元)，可享受特权(单次充电服务费8.5折)，且有1张卡券(单次充电服务费满足20元服务费9折)，',
    member_00020_2: '则使用等级用户特权后后，账单金额为95.5元(含电费70元，服务费25.5元(30*85%))，满足卡券(单次充电服务费满足20元服务费9折)。则使用卡券后，账单金额为92.95元(含电费70元+服务费22.95元(25.5*90%))，最终此次需实际支付92.95元。',
    member_00021: 'Die Website ausschließen',
    member_00022: 'Nach dem Hinzufügen einer Ladestation genießen Level-Benutzer keine Privilegien beim Laden an dieser Ladestation',
    member_00023: '添加排除场站',
    member_00024: 'Stationsname',
    member_00025: 'Operator',
    member_00026: 'Stationsdetails',
    member_00027: 'löschen',
    member_00028: 'Möchten Sie diese Site wirklich löschen?',
    member_00029: 'erfolgreich gelöscht',
    member_00030: 'Benutzerbereich: WeChat-Benutzer',
    member_00031: 'Level-Initialisierung',
    member_00032: 'bearbeiten',
    member_00033: 'Abbrechen',
    member_00034: 'speichern',
    member_00036: 'Level-Initialisierung',
    member_00035: '启用后请慎重设置用户等级相关参数，频繁修改可能会引起充电用户反感投诉。如重新设置，请重新对用户初始化等级。',
    member_00037: '升级/保级任务类型',
    member_00038: '(非团体且已支付充电订单)',
    member_00039: 'Einrichtungshilfe',
    member_00040: '升级任务：系统自动根据各等级用户所需的成长值进行升级，达到成长值即升级。',
    member_00040_1: '保级任务：系统自动根据各等级用户所需的免降值进行保级，达到免降值即保级，未达到免降值即降级。您可以选择是否开启保级任务。',

    member_00041: '免降值设置',
    member_00041_1: '用户通过充电消费获得免降值，当用户成长到新的等级时，需要在您设置的保级任务完成时间期内，获得保级要求的免降值，即可保级成功，反则降级。',
    member_00041_2: '例：当您设置开启保级任务，并设置为"每30日完成一次"，将VIP2的免降值设置为200，当用户从VIP1升级为VIP2时，需从升级当天起每30日获得',
    member_00041_3: '200免降值，才能保持VIP2等级，否则将降级成为VIP1。保级成功或失败的结果，将从保级任务完成周期后的第一天开始执行。',
    member_00042: 'Einstellung der Mitgliedschaftsstufe',
    member_00043: '开启保级任务',
    member_00044: 'Alle 30 Tage abgeschlossen',
    member_00045: 'Alle 90 Tage abgeschlossen',
    member_00046: 'Reihenfolge',
    member_00047: 'Mitgliedschaftsstufe (von niedrig nach hoch)',
    member_00048: 'Bitte geben Sie den Klassennamen ein',
    member_00049: 'Upgrade-Aufgabe',
    member_00050: 'Bitte geben Sie eine ganze Zahl ein',
    member_00051: 'Abstiegsaufgabe',
    member_00052: 'Level hinzufügen',
    member_00053: 'Falsches Format der Upgrade-Aufgabe/Abstiegs-Aufgabe',
    member_00054: 'Bitte geben Sie den Namen der Benutzerebene/Aufstiegsaufgabe/Abstiegsaufgabe ein',


    member_00055: 'Mitgliedervorteile',
    member_00056: 'Level-Benutzerrechtetyp',
    member_00057: 'Geben Sie 15% Rabatt für 15% Rabatt ein, geben Sie 0 kostenlos ein und geben Sie 100 ein, um keinen Rabatt zu erhalten.',
    member_00058: 'Notenname (Note von niedrig nach hoch)',
    member_00059: 'Vorteile auf Mitgliedsebene:',
    member_00060: 'Rabatte auf Einzelladungsverbrauch je nach Benutzerniveau. Wenn ein Level-Benutzer zu der Site geht, die an die Benutzergruppe gebunden ist, der er angehört, wird das Privileg der Benutzergruppe verwendet, und das Privileg des Level-Benutzers wird nicht verwendet. ',
    member_00061: 'Beispiel: Zum Beispiel, wenn die Einzelladegebühr des VIP- Benutzers auf 15% Rabatt eingestellt ist und die Ladegebühr des VIP - Benutzers dieses Mal 100 Yuan beträgt(einschließlich Stromgebühr von 70 Yuan und Servicegebühr von 30 Yuan), wird die Der tatsächliche Zahlungsbetrag beträgt diesmal 95.5(70 + 30 * 85% = 95.5). ',
    member_00062: 'Wenn die Gesamtgebühr für eine einzelne Gebühr für VIP - Benutzer auf 15% Rabatt eingestellt ist und die Gebühr für VIP - Benutzer dieses Mal 100 Yuan beträgt, beträgt der tatsächlich zu zahlende Betrag dieses Mal 85 Yuan(100 * 85% =85). ',
    member_00063: 'Das Rabattformat der Mitgliedsstufe ist falsch',
    member_00064: 'Bitte geben Sie den Rabatt der Mitgliedsstufe ein',
    member_00065: 'Bitte geben Sie den Stationsnamen/Betreibernamen ein',
    member_00066: 'Anfragen',
    member_00067: 'Stationsname',
    member_00068: 'Operator',
    member_00069: 'Stationsstatus',
    member_00070: 'Offen für die Außenwelt',
    member_00071: 'Ladestapel',
    member_00072: 'Abbrechen',
    member_00073: 'Hinzufügen',
    member_00074: 'Wachstumswerteinstellung:',
    member_00075: "Der Benutzer erhält den Wachstumswert durch Aufladen des Verbrauchs. Wenn der Wachstumswert des Benutzers die entsprechenden Level-Anforderungen erreicht, wird der Benutzer Mitglied des entsprechenden Levels. Der Wachstumswert wird nicht über die Ebenen hinweg kumuliert. Nach jedem Benutzer-Upgrade ist der anfängliche Wachstumswert 0. ",
    member_00076: "Beispiel: VIP1 benötigt einen Wachstumswert von 100, VIP2 benötigt einen Wachstumswert von 200, und wenn der Benutzer ein VIP1 ist, muss er einen weiteren Wachstumswert von 200 erhalten, um ein VIP2 zu werden. ",

    // 2022/1/17
    member_10000: 'Bei der eingabe der sparwerte',
    member_10001: 'Freie betätigung',
    member_00077: 'Level-Belohnung',
    member_00078: 'Wenn der Benutzer die Upgrade-Aufgabe/Abstiegsaufgabe abschließt, erhält der Benutzer die Belohnung. Upgrade-/Abstiegsboni werden nur wirksam, wenn die Mitgliedschaftsstufe aktiviert ist. ',
    member_00079: 'Ebenenname (von niedrig bis hoch)',
    member_00080: 'Upgrade-Bonus',
    member_00081: 'Abstiegsbelohnung',
    member_00082: 'Belohnungseinstellungen',
    member_00083: 'Gutscheine hinzufügen',
    member_00084: 'Wenn Sie einen Gutschein mit einer absoluten zeitlichen Gültigkeitsdauer hinzufügen, beachten Sie bitte, dass der Gutschein vor dem Ablaufdatum des Gutscheins aus der Prämie entfernt wird. ',
    member_00084: 'Bitte geben Sie den Kartennamen ein',
    member_00085: 'Kartentyp',
    member_00086: 'Gutscheinname',
    member_00087: 'Typ',
    member_00088: 'Bitte geben Sie ein Vielfaches von 100 ein, das Maximum ist 10000',
    member_00089: 'Ladekapazität',
    member_00090: 'Servicegebühr',
    member_00091: 'Referenzdaten',
    member_00092: 'Ein einzelner Benutzer ist kein Team und hat einen Ladeauftrag bezahlt',
    member_00093: 'Tatsächlich bezahlte Gesamtkosten',
    member_00094: 'Rabatt auf Mitgliedsebene',
    member_00095: "* Das System berechnet die Ladedaten jedes Ladebenutzers, den kumulativen Wachstumswert von der Startzeit bis jetzt und ordnet den Pegel gemäß den aktuell festgelegten Pegelregeln zu (der Berechnungsvorgang kann einige Zeit dauern, bitte warten Sie geduldig)< Br>, wenn Sie zuerst die Stabebene Funktion aktivieren und die Pegelparameter einstellen, wenn Sie alle Benutzer benötigen, um Wachstumswert von 0 zu akkumulieren, müssen Sie die Funktion 'Stabebene neu zuweisen' nicht verwenden< Wenn Sie zum ersten Mal die Stabebene-Funktion einschalten und die Pegelparameter einstellen, wenn Sie die Stabebene gemäß den historischen Ladedaten des Benutzers zuweisen müssen, verwenden Sie bitte die Funktion 'Stabebene neu zuweisen'< Br>, wenn Sie Gradparameter ändern Wenn Sie den Level-Namen festlegen oder ändern, den Level erhöhen, den Wachstumswert erhöhen und den Wert frei von Reduktion erhöhen, klicken Sie auf die Schaltfläche 'Speichern', um nach Abschluss der Einstellung wirksam zu werden. Es ist nicht erforderlich, 'Member Level neu zuweisen'< br>2. Wenn Sie den Wachstumswert reduzieren und den freien Reduktionswert reduzieren möchten, klicken Sie nach der Einstellung auf die Schaltfläche 'Speichern', um wirksam zu werden. Der von einigen Benutzern zuvor gesammelte Wachstumswert oder Reduktionsfreiwert kann nicht erfolgreich aktualisiert oder aktualisiert werden. Da Sie die Reduktion des Wachstumswertes oder des Reduktionsfreiwertes festlegen, erfüllen Sie die Upgrade- oder Schutzanforderungen. In diesem Fall kann der Benutzer die Upgrade- oder Schutzaufgabe nach einer Gebühr abschließen< Br. zum Beispiel: Sie setzen das für VP2 erforderliche Wachstum auf 200 vorher. Derzeit haben Sie es auf 150 geändert. Ein Benutzer hat 150-Wachstumswert vor der Änderung angesammelt. Nachdem Sie die Einstellung geändert haben, kann der Benutzer vip2 nach der nächsten Ladung aktualisieren< br>3. Wenn Sie eine reduzierte Stufe festlegen, verwenden Sie bitte die Funktion 'Mitgliederebene neu zuweisen' nach der Einstellung, um sicherzustellen, dass Benutzer die entsprechende neue Stufe erhalten< Br. zum Beispiel: Sie haben zuvor die Ebene als Stufe 5 und die höchste Ebene als VIP5 festgelegt. Nun legen Sie die Mitgliedsebene als Stufe 3 und die höchste Mitgliedsebene als vip3 fest. Die Mitgliedsebene eines Benutzers war vorher VIP5. Der Benutzer kann nur einer neuen Mitgliedsebene zugewiesen werden, wenn Sie 'Mitgliedsebene zurücksetzen' verwenden.",
    member_00096: 'Weiter',
    member_00097: 'Konversionsverhältnis',
    member_00098: 'Wachstumswert/Kein Drop-Wert',
    member_00099: '1 Grad Ladekapazität',
    member_000100: '1 Yuan Servicegebühr',
    member_000101: 'Tatsächlich bezahlte Gesamtkosten',
    member_000102: 'Zuletzt zugewiesene Zeit auf Mitgliedsebene:'
}
